module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/TOP-OF-THE-LAKE_S02.6f1539c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/TOP-OF-THE-LAKE_S02.jpg
// module id = DrMJ
// module chunks = 0